import React, { Component } from 'react'
import idGenerator from 'react-id-generator'
import Image from 'gatsby-image'
import { Link } from 'gatsby'

// Slider Component
import Slider from 'react-slick'
import ClampLines from 'react-clamp-lines'

// Slider styles
import './Slider.sass'

// Lets import images
import playVideo from '../../img/playVideo.svg'

// Lets import utils functions
import { utils } from '../../utils/index'


class VideosSlider extends Component {
  constructor(props) {
    super(props)
    this.state = {
      nav1: null,
      nav2: null,
    }
  }

  componentDidMount() {
    this.setState({
      nav1: this.slider1,
      nav2: this.slider2
    });
  }

  render () {
    const { slides, t, l } = this.props
    const filteredSlides = utils.getShuffedArr([...slides])
    const settings = {
      arrows: true,
      dots: true,
      infinite: false,
      speed: 500,
      slidesToShow: 4,
      slidesToScroll: 4,
      centerMode: false,
      responsive: [
        {
          breakpoint: 990,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
          }
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 500,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
      ]
    }
    return (
      <>
        <Slider 
          {...settings}>
          {filteredSlides.map(slide => {
            return (
              <div key={idGenerator()}>
                <div className="slideContent">
                  <Link to={`/${l.i18n.language}/${slide.slug}`}>
                    <div className="slideItem">
                      <div className="imageWrap">
                        <img className="play" src={playVideo} alt="play" />
                        {slide.thumbnail ? (
                          <Image fixed={slide.thumbnail.childImageSharp.fixed} alt="thumbnail" />
                        ) : null}
                      </div>
                      <div className="videoCountry">
                        <div className="badge">
                          {t(slide.country.toLowerCase())}
                        </div>
                      </div>
                      <div className="videoTitle">
                        {slide.title}
                      </div>
                      <div className="videoDescription">
                        <ClampLines
                          text={slide.description}
                          lines={2}
                          ellipsis="..."
                          className="description"
                          innerElement="p"
                          buttons={false}
                        />
                        <span className="readMore">read more</span>
                      </div>
                    </div>
                  </Link>
                </div>
              </div>
            )
          })}
        </Slider>
      </>
    )
  }
}

export default VideosSlider
